export default {
  WeTransfer_Site_Landing_Page_Overlay_Visit:
    'https://secure.adnxs.com/px?id=1121943&seg=18136936&t=2',
  WeTransfer_Site_Landing_Page_Overlay_WT_Free_Button_Conversion:
    'https://secure.adnxs.com/px?id=1121946&seg=18136942&t=2',
  WeTransfer_Site_Landing_Page_Overlay_WT_Plus_Button_Conversion:
    'https://secure.adnxs.com/px?id=1121947&seg=18136947&t=2',
  WeTransfer_Site_Landing_Page_Overlay_WT_Free_send_file_Conversion:
    'https://secure.adnxs.com/px?id=1121958&seg=18136996&t=2',
  WeTransfer_Site_Landing_Page_Overlay_WT_plus_send_file_Conversion:
    'https://secure.adnxs.com/px?id=1121960&seg=18136997&t=2',
  WeTransfer_Site_Landing_Page_Overlay_WT_Free_send_another_Conversion:
    'https://secure.adnxs.com/px?id=1121961&seg=18137003&t=2',
  WeTransfer_Completed_file_Conversion:
    'https://secure.adnxs.com/px?id=1121964&seg=18137048&t=2',
  WeTransfer_Sign_in_Visit:
    'https://secure.adnxs.com/px?id=1121966&seg=18137054&t=2',
  WeTransfer_Got_Plus:
    'https://secure.adnxs.com/px?id=1121968&seg=18137055&t=2',
  WeTransfer_Sign_Me_Up_Button_Conversion:
    'https://secure.adnxs.com/px?id=1121970&seg=18137059&t=2',
  WeTransfer_More_About_Plus_Button_Conversion:
    'https://secure.adnxs.com/px?id=1121978&seg=18137095&t=2',
  WeTransfer_Get_Plus_Conversion:
    'https://secure.adnxs.com/px?id=1121979&seg=18137116&t=2',
  Wetransfer_Plus_Complete_Order_Conv:
    'https://secure.adnxs.com/px?id=1123647&seg=18170180&t=2',
  WT_Plus_Add_Payment_Conv:
    'https://secure.adnxs.com/px?id=1123648&seg=18170232&t=2',
  WT_Plus_go_to_Check_out_Conv:
    'https://secure.adnxs.com/px?id=1123649&seg=18170245&t=2',
  WeTransfer_Plus_Complete_Payment_Button_1st_Conversion:
    'https://secure.adnxs.com/px?id=1121984&seg=18137128&t=2',
  WeTransfer_Plus_Complete_Payment_Button_return_Conversion:
    'https://secure.adnxs.com/px?id=1121985&seg=18137133&t=2',
  WeTransfer_Plus_Confirmation_Page_Conversion:
    'https://secure.adnxs.com/px?id=1121988&seg=18137137&t=2',
  WeTransfer_Reactivate_Plus_Go_Ahead_Conversion:
    'https://secure.adnxs.com/px?id=1123646&seg=18170152&t=2',
  WeTransfer_Upload_Avatar_Conversion:
    'https://secure.adnxs.com/px?id=1121990&seg=18137152&t=2',
  WeTransfer_Upload_Profile_Personal:
    'https://secure.adnxs.com/px?id=1121991&seg=18137158&t=2',
  WeTransfer_Profile_Choose_Background_default_Conversion:
    'https://secure.adnxs.com/px?id=1121992&seg=18137186&t=2',
  WeTransfer_Profile_Choose_Background_upload_Conversion:
    'https://secure.adnxs.com/px?id=1121993&seg=18137193&t=2',
  WeTransfer_Account_Cancel_Subscription_Click:
    'https://secure.adnxs.com/px?id=1121998&seg=18137203&t=2',
  WeTransfer_Account_Cancel_Subscription_Go_Ahead_Click:
    'https://secure.adnxs.com/px?id=1122000&seg=18137205&t=2',
  WeTransfer_Account_Reactivate_Plus_Conversion:
    'https://secure.adnxs.com/px?id=1122002&seg=18137223&t=2',
  WeTransfer_Add_Contact_Conversion:
    'https://secure.adnxs.com/px?id=1122003&seg=18137226&t=2',
  WeTransfer_Social_Clickout_Conversion:
    'https://secure.adnxs.com/px?id=1122004&seg=18137233&t=2',
};
